export const wordList = [
  { name: 'spg', value: 'SPG' },
  { name: 'closure_report', value: 'Closure Report' },
  { name: 'location', value: 'Location' },
  { name: 'procurement_report', value: 'Procurement Report' },
  { name: 'rec_drawing', value: 'REC Drawing' },
  { name: 'landlord_assessment', value: 'Landlord Assessment' },
  { name: 'site_condition', value: 'Site Condition' },
  { name: 'outside_lease_line_fire_check', value: 'Outside Lease Line Fire Check' },
  { name: 'fire_design', value: 'Fire Design' },
  { name: 'confirmation_file', value: 'BP & FIN Confirmation File' },
  { name: 'consumer_survey', value: 'Consumer Survey' },
  { name: 'traffic_survey', value: 'Traffic Survey' },
  { name: 'project_report', value: 'Project Report' },
  { name: 'cad', value: 'CAD' },
  { name: 'ssr', value: 'SSR' },
  { name: 'kick_off_deck', value: 'Kick-off Deck' },
  { name: 'checklist', value: 'Checklist' },
  { name: 'local_brand_mix', value: 'Location & Brand Mix' },
  { name: 'complete_spg', value: 'Complete SPG' },
  { name: 'project_deck', value: 'Project Deck' },
  { name: 'project_checklist', value: 'Project Checklist' },
  { name: 'complete_spg', value: 'Complete SPG' },
  { name: 'zoning_plan', value: 'Zoning Plan' },
  { name: 'floor_plan', value: 'Floor Plan' },
  { name: 'rendering', value: 'Rendering' },
  { name: 'cd', value: 'CD' },
  { name: 'egd', value: 'EGD' },
  { name: 'fin-spko', value: 'FIN Spko' },
  { name: 'ce-vision', value: 'CE Vision' },
  { name: 'ce_vision', value: 'CE Vision' },
  { name: 'fleet-plan', value: 'Fleet Plan' },
  { name: 'revenue', value: 'Revenue' },
  { name: 'investment', value: 'Investment' },
  { name: 'punch_list', value: 'Punch List' },
  { name: 'finance_spko', value: 'Finance SPKO' },
  { name: 'ce_vision', value: 'CE Vision' },
  { name: 'geo_mp_aop', value: 'Geo MP AOP' },
  { name: 'terri_mp_adjusted_aop', value: 'Terri MP Adjusted AOP' },
  { name: 'geo_terri_mp_aligned_aop', value: 'Geo & Terri MP aligned AOP' },
  { name: 'mp_acct_aligned_aop', value: 'MP & Acct aligned AOP' },
  { name: 'finalized_aop', value: 'Finalized AOP' },
  {
    name: 'mp_acct_bp_fin_aligned_aop',
    value: 'MP & Acct & BP & Fin aligned AOP',
  },
  { name: 'bp_fin_reviewed_aop', value: 'BP & Fin Reviewed AOP' },
  { name: 'geo_mp_csr', value: 'Geo MP CSR' },
  { name: 'terri_mp_adjusted_csr', value: 'Terri MP Adjusted CSR' },
  { name: 'geo_terri_mp_aligned_csr', value: 'MP & Acct aligned CSR' },
  { name: 'finalized_csr', value: 'Finalized CSR' },
  {
    name: 'mp_acct_bp_fin_aligned_csr',
    value: 'MP & Acct & BP & Fin aligned CSR',
  },
  { name: 'pipeline_information', value: 'Pipeline Information' },
  { name: 'document_review', value: 'Document Review' },
  { name: 'global_rec', value: 'Global REC' },
  { name: 'cd_drawing', value: 'CD Drawing' },
  { name: 'site_fire', value: 'Site Condition & Fire Design' },
  { name: 'outside_lease', value: 'Outside Lease Line Fire Check' },
  { name: 'global_ticket', value: 'Global Ticket' },
  { name: 'third_party', value: 'Third Party Review Documents' },
  { name: 'construction_permit', value: 'Construction Permit' },
  { name: 'fire_permit', value: 'Fire Permit' },
  { name: 'mix_for_new_door', value: 'Floor Plan vs Brand Mix for New Door' },
  { name: 'mix_for_reno_door_before', value: 'Floor Plan vs Brand Mix for Reno Door - BEFORE' },
  { name: 'mix_for_reno_door_after', value: 'Floor Plan vs Brand Mix for Reno Door - AFTER' },
  { name: 'mix_1st_reno_floor', value: 'Floor Plan vs Brand Mix – 1st Floor' },
  { name: 'finance_document', value: 'Finance Document' },
  { name: 'rec_deck', value: 'REC DECK' },
]

export function transformWord(data: string) {
  const list = wordList
  let result = ''
  list.map((item) => {
    if (item.name === data) {
      result = item.value
    }
  })
  if (result === '') {
    if (data.indexOf('_') > 0) {
      let newArray = data.split('_').map((item) => {
        return item.slice(0, 1).toUpperCase() + item.slice(1)
      })
      result = newArray.join(' ')
    } else {
      result = data.slice(0, 1).toUpperCase() + data.slice(1)
    }
  }
  return result
}

export function transformDoorType(data = '') {
  return data.replace(/^\w|_\w/g, function (val) {
    return val.toUpperCase().replace('_', ' ')
  })
}

export function sortChinese(arr: string[]) {
  return arr.sort((a, b) => a.localeCompare(b, 'zh-Hans-CN'))
}

export function sortEnglish(arr: string[]) {
  return arr.sort((a, b) => a.localeCompare(b, 'en'))
}

export const getFormat = (value: string): { label: string; extensions: string[] } => {
  if (value == 'detailed_assessment') {
    return { label: 'PPT', extensions: ['.ppt', '.pptx'] }
  } else if (value == 'location') {
    return { label: 'PPT', extensions: ['.ppt', '.pptx'] }
  } else if (value == 'mix_for_new_door' || value == 'mix_1st_reno_floor') {
    return { label: 'PNG/JPG/JPEG', extensions: ['.png', '.jpg', '.jpeg'] }
  } else if (
    // todo: 老项目写法，先注释掉
    // this.props.record.format === 'KEY' &&
    value == 'mix_for_reno_door_before' ||
    value == 'mix_for_reno_door_after'
  ) {
    return { label: 'PNG/JPG/JPEG', extensions: ['.png', '.jpg', '.jpeg'] }
  } else if (
    value == 'landlord_assessment' ||
    value == 'complete_spg' ||
    value == 'spg' ||
    value == 'project_report' ||
    value == 'site_condition' ||
    value == 'confirmation_file'
  ) {
    return { label: 'PPT/PDF', extensions: ['.ppt', '.pptx', '.pdf'] }
  } else if (
    value == 'fp' ||
    value == 'cd' ||
    value == 'procurement_report' ||
    value == 'rec_drawing' ||
    value == 'working_letter' ||
    value == 'closure_report'
  ) {
    return { label: 'PDF', extensions: ['.pdf'] }
  } else if (
    value == 'rec_deck' ||
    value == 'fire_design' ||
    value == 'outside_lease' ||
    value == 'fire_permit' ||
    value == 'contract_document' ||
    value == 'global_ticket' ||
    value == 'third_party' ||
    value == 'construction_permit' ||
    value == 'pipeline_information'
  ) {
    return { label: 'Any Type Allowed', extensions: [] }
  } else if (
    value == 'facade' ||
    value == 'wide_view' ||
    value == 'cashier_counter' ||
    value == 'fitting_room' ||
    value == 'staircase' ||
    value == 'footwear_wall' ||
    value == 'others_photo'
  ) {
    return { label: 'PNG/JPG/JPEG', extensions: ['.png', '.jpg', '.jpeg'] }
  } else {
    return { label: '', extensions: [] }
  }
}
